import { MOODS, type MoodValue } from '@/domain/health/journal'

/** Original soft dumplings drawn in SVG, shared by the picker and daily history. */
export function MoodDumpling({ mood }: { mood: MoodValue }) {
  return (
    <svg className="mood-dumpling" viewBox="0 0 88 84" fill="none" aria-hidden="true">
      <ellipse cx="44" cy="75" rx="24" ry="3" fill="#b3a291" opacity=".1" />
      <path
        d="M11 52C11 31 24 16 43 16C63 16 77 31 77 52C77 66 69 73 56 71C48 74 38 74 30 71C17 73 11 66 11 52Z"
        fill={MOODS[mood - 1]!.color}
      />
      <path d="M23 34C26 28 31 25 37 24" stroke="#fff" strokeWidth="5" strokeLinecap="round" opacity=".42" />
      <ellipse cx="27" cy="54" rx="5.5" ry="3" fill="#e9a9a0" opacity=".4" />
      <ellipse cx="61" cy="54" rx="5.5" ry="3" fill="#e9a9a0" opacity=".4" />
      <g stroke="#6c5c55" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
        {mood === 1 ? (
          <>
            <path d="m30 45 5 2m18 0 5-2M40 57q4-4 8 0" />
            <path d="M31 52c-1 2-3 4-3 6a3 3 0 0 0 6 0c0-2-2-4-3-6Z" fill="#9dbdd5" stroke="none" />
          </>
        ) : mood === 2 ? (
          <><path d="M33 47v2m22-2v2M41 57q3-3 6 0" /></>
        ) : mood === 3 ? (
          <><path d="M33 45v3m22-3v3M42 56h4" /></>
        ) : mood === 4 ? (
          <><path d="M29 47q4-5 8 0m14 0q4-5 8 0M40 55q4 5 8 0" /></>
        ) : (
          <>
            <path d="M28 46q5-7 10 0m12 0q5-7 10 0" />
            <path d="M38 53q6 2 12 0c0 9-12 9-12 0Z" fill="#af7770" strokeWidth="1.5" />
            <path d="M41 58q3-2 6 0" stroke="#f2b5aa" strokeWidth="2" />
          </>
        )}
      </g>
      {mood === 5 ? <path d="m73 20 1.5 4.5L79 26l-4.5 1.5L73 32l-1.5-4.5L67 26l4.5-1.5Z" fill="#e9c57c" /> : null}
    </svg>
  )
}
